var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoClipRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.25C3 7.25544 3.39509 6.30161 4.09835 5.59835C4.80161 4.89509 5.75544 4.5 6.75 4.5H17.25C18.2446 4.5 19.1984 4.89509 19.9016 5.59835C20.6049 6.30161 21 7.25544 21 8.25V15.75C21 16.7446 20.6049 17.6984 19.9016 18.4017C19.1984 19.1049 18.2446 19.5 17.25 19.5H6.75C5.75544 19.5 4.80161 19.1049 4.09835 18.4017C3.39509 17.6984 3 16.7446 3 15.75V8.25ZM9.75 8.73V15.27C9.75 15.645 10.161 15.8745 10.4805 15.6795L15.369 12.6915C15.4876 12.6192 15.5855 12.5176 15.6535 12.3965C15.7215 12.2754 15.7572 12.1389 15.7572 12C15.7572 11.8611 15.7215 11.7246 15.6535 11.6035C15.5855 11.4824 15.4876 11.3808 15.369 11.3085L10.479 8.322C10.4063 8.27787 10.3231 8.25386 10.2381 8.25243C10.153 8.251 10.0691 8.27221 9.99492 8.31387C9.92075 8.35553 9.85898 8.41616 9.81595 8.48954C9.77291 8.56293 9.75015 8.64493 9.75 8.73Z",
    fill: "#CF283A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoClipRed);
export default __webpack_public_path__ + "static/media/video-clip-red.80317122d4f8281bce451adbad28cba8.svg";
export { ForwardRef as ReactComponent };